export const SESSION_DATA_NAME = 'AHA_BACKEND_APP_SESSION';
export const QUEST_WIZARD_DATA_SESSION_KEY_NAME = 'QUEST_WIZARD_DATA';

export const DATE_FORMAT = 'YYYY-MM-DD';
export const TIME_FORMAT = 'HH:mm';
export const DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mmz';

export const COPY_KEY = 'Duplicated';

export const BASIC_QUEST_INDEXNAME = 'basic';
export const PERIODIC_QUEST_INDEXNAME = 'periodic';
export const ONLINE_QUEST_INDEXNAME = 'online';

export const GALLERY_PATH = '/uploads';

export const QUEST_WIZARD_DATA_MISSING_ERROR = 'QUEST_WIZARD_DATA_MISSING_ERROR';

export const DEVICE_TOKEN = 'DEVICE_TOKEN';

export const MAGIC_LOGIN_TOKEN_PARAMETER = 'magic-login-token';
export const FORCE_LOGIN_PARAMETER = 'forceLogin';
